export function findVisibleTabRange(tabItems, availableWidth, selectedIndex, gap, separatorW) {
    if (selectedIndex < 0 || selectedIndex >= tabItems.length) {
        return { startIndex: 0, endIndex: 0 };
    }
    let currentWidth = tabItems[selectedIndex].offsetWidth + gap + separatorW + gap;
    let startIndex = selectedIndex;
    let endIndex = selectedIndex;
    let leftIndex = selectedIndex - 1;
    while (leftIndex >= 0 && currentWidth < availableWidth) {
        const tabWidth = tabItems[leftIndex].offsetWidth + gap + separatorW + gap;
        if (currentWidth + tabWidth > availableWidth) {
            break;
        }
        currentWidth += tabWidth;
        startIndex = leftIndex;
        leftIndex--;
    }
    if (leftIndex < 0) {
        let rightIndex = selectedIndex + 1;
        while (rightIndex < tabItems.length && currentWidth < availableWidth) {
            const tabWidth = tabItems[rightIndex].offsetWidth + gap + separatorW + gap;
            if (currentWidth + tabWidth > availableWidth) {
                break;
            }
            currentWidth += tabWidth;
            endIndex = rightIndex;
            rightIndex++;
        }
    }
    return { startIndex, endIndex };
}
